import { deleteCookie, getCookie } from "../../utils"
import { authStatusCookie, pluginTypeCookie, languageCookie, currentOrgIdCookie, userDisplayNameCookie, loginModeCookie, invitationCookie } from "../../utils/cookies";
import { onWindowBlurListener, visibilityChangeListner } from "../firebase/firebase";

//0.04152778 is days and is equal to approx 60 mins which is generally expiry time from diff auth channels
// 0.000173611 days = 15 sec (can be used for testing)
export const accessTokenExpiryTime = 0.04152778

// in mins
export const autoLogoutTime = 120

// in mins (5 min)
// 5 min = 0.00347222 days
export const inviteCookieExpiryTime = 0.00347222

export function commonAuthDeleteCookies() {
    const toDeleteCookies = [currentOrgIdCookie, userDisplayNameCookie, loginModeCookie, invitationCookie]
    toDeleteCookies.forEach((cookie) => {
        deleteCookie(cookie)
    })

    commonRemoveAuthEvents()
}

export function commonAuthTracking({ tracking, user, type = "Sign In" }) {
    if (tracking) {
        tracking.people.set({
            $email: user.email.toLowerCase(),
            uid: user.uid,
            $distinct_id: user.uid,
            $name: user.displayName,
            USER_ID: user.displayName,
        });
        tracking.track(type);
    }
}


export async function commonAuthHeaders(headers) {
    // cookies
    const lang = getCookie(languageCookie);
    const currentOrgId = getCookie(currentOrgIdCookie);
    const pluginType = getCookie(pluginTypeCookie)
    const authStatus = getCookie(authStatusCookie);

    const newHeaders = {
        ...headers,
        "Apollo-Require-Preflight": true,
    };

    if (lang) newHeaders["Accept-Language"] = lang;


    if (authStatus === "true") {
        newHeaders.organizationId = currentOrgId;
        if (pluginType) newHeaders.pluginType = pluginType
        return newHeaders
    } else {
        return headers
    }
}

export function commonRemoveAuthEvents() {
    document.removeEventListener("visibilitychange", visibilityChangeListner);
    window.removeEventListener("blur", onWindowBlurListener);
}